import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IDateStyle } from "../../../../documaker/domain/format/objects";

export interface IDateStylePropertyEditable {
  dateStyle(): IPropertyEditable<IDateStyle>;
}

export function instanceOfIDateStylePropertyEditable(instance: any): instance is IDateStylePropertyEditable {
  return instance
      && instance.dateStyle
      && instanceOfIPropertyEditable<IDateStyle>(instance.dateStyle());
}
